import PropTypes from 'prop-types';
import React from 'react';

import { BACKGROUND_MAP, BRAND_NAME, LOGO_WHITE } from '../consts/Brand/brand';

const ErrorPage = ({
    title = '',
    subtitle = 'Something went wrong',
    message = 'Please try again later',
}) => (
    <div className="flex flex-col justify-center items-center w-full h-full relative p-2 bg-gradient-radial from-black-300 to-black-200 backdrop-blur-sm">
        <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center z-[-1] overflow-hidden p-[4em] opacity-75">
            <img
                className="h-full max-h-full max-w-none"
                src={BACKGROUND_MAP}
                alt={`${BRAND_NAME} World Map`}
            />
        </div>
        <div className="my-8 sm:mx-auto sm:w-full sm:max-w-md max-h-full overflow-auto">
            <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
                <h1 className="flex items-center justify-center text-4xl">
                    <i className="material-icons mr-1 text-red-600">error</i>
                    <span>{title}</span>
                </h1>
                <h2 className="text-2xl text-center text-black-300 my-4">
                    {subtitle}
                </h2>
                <div className="text-md text-center text-black-400 pt-4 border-t border-gray-100">
                    {message}
                </div>
            </div>
        </div>
        <div className="absolute bottom-6 flex justify-center">
            <img
                className="h-14 w-auto"
                src={LOGO_WHITE}
                alt={`${BRAND_NAME} Logo`}
            />
        </div>
    </div>
);

ErrorPage.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default ErrorPage;
